"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _classCallCheck = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/createClass.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getData = void 0;

var dataType_1 = require("./validate/dataType");

var util_1 = require("./util");

var errors_1 = require("./errors");

var codegen_1 = require("./codegen");

var names_1 = require("./names");

var subschema_1 = require("./subschema");

var KeywordCxt = /*#__PURE__*/function () {
  function KeywordCxt(it, def, keyword) {
    _classCallCheck(this, KeywordCxt);

    validateKeywordUsage(it, def, keyword);
    this.gen = it.gen;
    this.allErrors = it.allErrors;
    this.keyword = keyword;
    this.data = it.data;
    this.schema = it.schema[keyword];
    this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
    this.schemaValue = util_1.schemaRefOrVal(it, this.schema, keyword, this.$data);
    this.schemaType = def.schemaType;
    this.parentSchema = it.schema;
    this.params = {};
    this.it = it;
    this.def = def;

    if (this.$data) {
      this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
    } else {
      this.schemaCode = this.schemaValue;

      if (!validSchemaType(this.schema, def.schemaType, def.allowUndefined)) {
        throw new Error("".concat(keyword, " value must be ").concat(JSON.stringify(def.schemaType)));
      }
    }

    if ("code" in def ? def.trackErrors : def.errors !== false) {
      this.errsCount = it.gen.const("_errs", names_1.default.errors);
    }
  }

  _createClass(KeywordCxt, [{
    key: "result",
    value: function result(condition, successAction, failAction) {
      this.gen.if(codegen_1.not(condition));
      if (failAction) failAction();else this.error();

      if (successAction) {
        this.gen.else();
        successAction();
        if (this.allErrors) this.gen.endIf();
      } else {
        if (this.allErrors) this.gen.endIf();else this.gen.else();
      }
    }
  }, {
    key: "pass",
    value: function pass(condition, failAction) {
      this.result(condition, undefined, failAction);
    }
  }, {
    key: "fail",
    value: function fail(condition) {
      if (condition === undefined) {
        this.error();
        if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize

        return;
      }

      this.gen.if(condition);
      this.error();
      if (this.allErrors) this.gen.endIf();else this.gen.else();
    }
  }, {
    key: "fail$data",
    value: function fail$data(condition) {
      if (!this.$data) return this.fail(condition);
      var schemaCode = this.schemaCode;
      this.fail(codegen_1._(_templateObject || (_templateObject = _taggedTemplateLiteral(["", " !== undefined && (", ")"])), schemaCode, codegen_1.or(this.invalid$data(), condition)));
    }
  }, {
    key: "error",
    value: function error(append) {
      ;
      (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error);
    }
  }, {
    key: "$dataError",
    value: function $dataError() {
      errors_1.reportError(this, this.def.$dataError || errors_1.keyword$DataError);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
      errors_1.resetErrorsCount(this.gen, this.errsCount);
    }
  }, {
    key: "ok",
    value: function ok(cond) {
      if (!this.allErrors) this.gen.if(cond);
    }
  }, {
    key: "setParams",
    value: function setParams(obj, assign) {
      if (assign) Object.assign(this.params, obj);else this.params = obj;
    }
  }, {
    key: "block$data",
    value: function block$data(valid, codeBlock) {
      var _this = this;

      var $dataValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : codegen_1.nil;
      this.gen.block(function () {
        _this.check$data(valid, $dataValid);

        codeBlock();
      });
    }
  }, {
    key: "check$data",
    value: function check$data() {
      var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : codegen_1.nil;
      var $dataValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : codegen_1.nil;
      if (!this.$data) return;
      var gen = this.gen,
          schemaCode = this.schemaCode,
          schemaType = this.schemaType,
          def = this.def;
      gen.if(codegen_1.or(codegen_1._(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", " === undefined"])), schemaCode), $dataValid));
      if (valid !== codegen_1.nil) gen.assign(valid, true);

      if (schemaType.length || def.validateSchema) {
        gen.elseIf(this.invalid$data());
        this.$dataError();
        if (valid !== codegen_1.nil) gen.assign(valid, false);
      }

      gen.else();
    }
  }, {
    key: "invalid$data",
    value: function invalid$data() {
      var gen = this.gen,
          schemaCode = this.schemaCode,
          schemaType = this.schemaType,
          def = this.def,
          it = this.it;
      return codegen_1.or(wrong$DataType(), invalid$DataSchema());

      function wrong$DataType() {
        if (schemaType.length) {
          /* istanbul ignore if */
          if (!(schemaCode instanceof codegen_1.Name)) throw new Error("ajv implementation error");
          var st = Array.isArray(schemaType) ? schemaType : [schemaType];
          return codegen_1._(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), dataType_1.checkDataTypes(st, schemaCode, it.opts.strict, dataType_1.DataType.Wrong));
        }

        return codegen_1.nil;
      }

      function invalid$DataSchema() {
        if (def.validateSchema) {
          var validateSchemaRef = gen.scopeValue("validate$data", {
            ref: def.validateSchema
          }); // TODO value.code for standalone

          return codegen_1._(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["!", "(", ")"])), validateSchemaRef, schemaCode);
        }

        return codegen_1.nil;
      }
    }
  }, {
    key: "subschema",
    value: function subschema(appl, valid) {
      return subschema_1.applySubschema(this.it, appl, valid);
    }
  }, {
    key: "mergeEvaluated",
    value: function mergeEvaluated(schemaCxt, toName) {
      var it = this.it,
          gen = this.gen;
      if (!it.opts.unevaluated) return;

      if (it.props !== true && schemaCxt.props !== undefined) {
        it.props = util_1.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
      }

      if (it.items !== true && schemaCxt.items !== undefined) {
        it.items = util_1.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
      }
    }
  }, {
    key: "mergeValidEvaluated",
    value: function mergeValidEvaluated(schemaCxt, valid) {
      var _this2 = this;

      var it = this.it,
          gen = this.gen;

      if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
        gen.if(valid, function () {
          return _this2.mergeEvaluated(schemaCxt, codegen_1.Name);
        });
        return true;
      }
    }
  }]);

  return KeywordCxt;
}();

exports.default = KeywordCxt;

function validSchemaType(schema, schemaType) {
  var allowUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // TODO add tests
  return !schemaType.length || schemaType.some(function (st) {
    return st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined";
  });
}

function validateKeywordUsage(_ref, def, keyword) {
  var schema = _ref.schema,
      opts = _ref.opts,
      self = _ref.self;

  /* istanbul ignore if */
  if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) {
    throw new Error("ajv implementation error");
  }

  var deps = def.dependencies;

  if (deps === null || deps === void 0 ? void 0 : deps.some(function (kwd) {
    return !Object.prototype.hasOwnProperty.call(schema, kwd);
  })) {
    throw new Error("parent schema must have dependencies of ".concat(keyword, ": ").concat(deps.join(",")));
  }

  if (def.validateSchema) {
    var valid = def.validateSchema(schema[keyword]);

    if (!valid) {
      var msg = "keyword value is invalid: " + self.errorsText(def.validateSchema.errors);
      if (opts.validateSchema === "log") self.logger.error(msg);else throw new Error(msg);
    }
  }
}

var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;

function getData($data, _ref2) {
  var dataLevel = _ref2.dataLevel,
      dataNames = _ref2.dataNames,
      dataPathArr = _ref2.dataPathArr;
  var jsonPointer;
  var data;
  if ($data === "") return names_1.default.rootData;

  if ($data[0] === "/") {
    if (!JSON_POINTER.test($data)) throw new Error("Invalid JSON-pointer: ".concat($data));
    jsonPointer = $data;
    data = names_1.default.rootData;
  } else {
    var matches = RELATIVE_JSON_POINTER.exec($data);
    if (!matches) throw new Error("Invalid JSON-pointer: ".concat($data));
    var up = +matches[1];
    jsonPointer = matches[2];

    if (jsonPointer === "#") {
      if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
      return dataPathArr[dataLevel - up];
    }

    if (up > dataLevel) throw new Error(errorMsg("data", up));
    data = dataNames[dataLevel - up];
    if (!jsonPointer) return data;
  }

  var expr = data;
  var segments = jsonPointer.split("/");

  var _iterator = _createForOfIteratorHelper(segments),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var segment = _step.value;

      if (segment) {
        data = codegen_1._(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", "", ""])), data, codegen_1.getProperty(util_1.unescapeJsonPointer(segment)));
        expr = codegen_1._(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", " && ", ""])), expr, data);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return expr;

  function errorMsg(pointerType, up) {
    return "Cannot access ".concat(pointerType, " ").concat(up, " levels up, current level is ").concat(dataLevel);
  }
}

exports.getData = getData;